import { RouteRecordRaw } from 'vue-router';
import { AdminDepartmentsPage } from '@/pages/admin';

export const routeName = 'AdminDepartamentos';

export const route: RouteRecordRaw = {
  path: 'departamentos',
  name: routeName,
  component: AdminDepartmentsPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Departamentos',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
};
